import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { ApiResponse } from '@shared/models/api-response.model';

@Injectable({
  providedIn: 'root'
})
export class ReferralDataService {

  constructor(private http: HttpClient) { }

  getDetails(): Observable<any> {
    return this.http.get<ApiResponse>('/referral/details').pipe(
      map(res => res.data.rows)
    );
  }

  getAll(): Observable<any[]> {
    return this.http.get<ApiResponse>('/referralcontent').pipe(
      map(res => res.data.rows)
    );
  }
}
